import { Box, Button, Container, Typography } from "@mui/material";
// import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Arrow from "../../../assets/images/arrowroundzoom.svg";
import StrengthBg from "../../../assets/images/product-bg.svg";
// import { usePostStore } from "../../../store/postStore";
import ServiceCard from "../ServiceCard";

const ProductSection = ({ products }) => {
  const isMobile = window.innerWidth < 600; // Check if the screen width is less than 600px
  const navigate = useNavigate();

  // const { products, getPosts } = usePostStore();

  // useEffect(() => {
  //   getPosts("products");
  // }, [getPosts]);
  return (
    <Box
      sx={{
        backgroundImage: `url(${StrengthBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center, center",
        width: "100%",
        display: "flex",
        // flexDirection: "column",
        // justifyContent: "center",
        alignItems: "center",
        // textAlign: "center",
        color: "#fff",
        // padding: 2,
        backgroundRepeat: "no-repeat",
        backgroundColor: "#f8f8f8;",
      }}
    >
      <Container>
        <Box py={7}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              background: "linear-gradient(180deg, #F8B62D 0%, #EA5514 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: 700,
              fontSize: {
                xs: "14px",
                sm: "24px",
              },
              lineHeight: "33px",
              marginBottom: 0,
            }}
          >
            Product
          </Typography>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontSize: {
                xs: "18px",
                sm: "50px",
              },
              color: "#000000",
              lineHeight: {xs:'20px',md:"70px"},

            }}
          >
            プロダクト
          </Typography>
          <Typography
            // mt={6}
            variant="body1"
            gutterBottom
            sx={{
              fontWeight: 400,
              lineHeight: "36px",
              fontSize: {
                xs: "14px",
                sm: "20px",
              },
              color: "#000000",
              mt: {
                xs: 0,
                sm: 3,
              },
            }}
          >
            ノーコードで複数のデータを一元管理できます。
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            sx={{
              fontWeight: 400,
              lineHeight: "36px",
              fontSize: "20px",
              color: "#000000",
            }}
          >
            よりビジネスの成長にコミットしたデータ活用ができます。
          </Typography>
          {!isMobile && (
            <hr
              style={{
                borderTop: "1px solid #EEEEEE",
                marginTop: "3em",
                marginBottom: "1.3em",
              }}
            />
          )}
          {products.map((product, index) => (
            <ServiceCard index={index} service={product} slug={"products"} />
            // <InsightCard
            //   key={index}
            //   number={item.number}
            //   image={item.image}
            //   title={item.title}
            //   description={item.description}
            // />
          ))}
          {!isMobile && <hr style={{ borderTop: "1px solid #EEEEEE" }} />}

          <Box
            display="flex"
            justifyContent="center"
            sx={{
              mt: {
                xs: 0,
                sm: 4,
              },
            }}
          >
            <Button
              variant="contained"
              sx={{
                color: "#fff",
                display: "flex",
                alignItems: "center",
                borderRadius: "30px",
                fontSize: "14px",
                width: "auto",
                height: "50px",
                fontWeight: 700,
                fontFamily: "Noto Sans JP, sans-serif",
                padding: "10px 10px 10px 20px",
                background: "linear-gradient(180deg, #F8B62D 0%, #EA5514 100%)",
                transition: "background 0.4s ease, color 0.4s ease",
                "&:hover": {
                  background: "black",
                  color: "white",
                  "& img": {
                    transform: "scale(1.2)",
                  },
                },
              }}
              onClick={() => navigate("/products/")}
            >
              事業内容へ
              <Box
                component="img"
                src={Arrow}
                alt="Button image"
                sx={{
                  height: "30px",
                  width: "30px",
                  ml: 3,
                  transition: "transform 0.3s ease",
                  transform: "scale(1)",
                }}
              />
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ProductSection;
